import type { ReactNode } from 'react'
import { Navigate } from 'react-router'
import type { Capability } from '@/api/pending'
import { env } from '@/app/env'
import { useAccess } from './useAccess'
import { NoSectionsScreen } from './screens'
import { firstAllowedPath } from './sections'

/** Renders children only when the capability is held (and the section isn't dark in this env). */
export function RequireCapability({
  capability,
  children,
}: {
  capability: Capability
  children: ReactNode
}) {
  const { capabilities, condoId, sections } = useAccess()
  const section = sections.find((s) => s.capability === capability)
  if (capabilities.has(capability) && section) return <>{children}</>
  const fallback = firstAllowedPath(condoId, capabilities, env.features)
  return fallback ? <Navigate to={fallback} replace /> : <NoSectionsScreen />
}

/** Index and unknown paths under /c/:condoId land on the first allowed section. */
export function FirstSectionRedirect() {
  const { capabilities, condoId } = useAccess()
  const target = firstAllowedPath(condoId, capabilities, env.features)
  return target ? <Navigate to={target} replace /> : <NoSectionsScreen />
}
